import { zhCN, zhTW, ja, enUS, enIN, enAU } from 'date-fns/locale'
import { toDate, format, utcToZonedTime } from 'date-fns-tz'

export default class DateFns {
	localeMapping: {
		[key: string]: string
	}

	timezoneMapping: {
		[key: string]: string
	}

	constructor() {
		this.localeMapping = {
			zh_TW: 'zhTW',
			zh_MO: 'zhTW',
			zh_HK: 'zhTW',
			zh_CN: 'zhCN',
			ja: 'ja',
			en_US: 'enUS',
			en_SG: 'enUS',
			en_PH: 'enUS',
			en_MY: 'enUS',
			en_IN: 'enIN',
			en_AU: 'enAU',
			en_AE: 'enUS',
		}

		this.timezoneMapping = {
			tw: 'Asia/Taipei',
			hk: 'Asia/Hong_Kong',
			cn: 'Asia/Shanghai',
			mo: 'Asia/Macau',
			jp: 'Asia/Tokyo',
			sg: 'Asia/Singapore',
			my: 'Asia/Kuala_Lumpur',
			in: 'Asia/Kolkata',
			ae: 'Asia/Dubai',
			au: 'Australia/Sydney',
			ph: 'Asia/Taipei',
		}
	}

	getLocale(lang: string) {
		const locale = this.localeMapping[lang]
		switch (locale) {
			case 'zhTW':
				return zhTW
			case 'zhCN':
				return zhCN
			case 'ja':
				return ja
			case 'enUS':
				return enUS
			case 'enIN':
				return enIN
			case 'enAU':
				return enAU
			default:
				return enUS
		}
	}

	getTimeZone(country: string) {
		const timezone = this.timezoneMapping[country]
		return timezone
	}

	translateOffset2TimeZone(offset: string) {
		const isNegative = offset[0] === '-'
		const hoursMatch = offset.match(/\d+/)
		const minutes = offset.match(/\.\d+$/)
		const hours = hoursMatch === null ? '0' : hoursMatch[0]
		const hoursStr = hours.length === 1 ? `0${hours}` : hours
		const minutesStr =
			minutes === null
				? '00'
				: (parseInt(minutes[0].replace('.', ''), 10) * 6).toString()
		return (isNegative ? '-' : '+') + hoursStr + minutesStr
	}

	formatDate(
		date: Date | number,
		pattern: string,
		lang: string,
		timeZone?: string,
	) {
		const locale = this.getLocale(lang)
		if (timeZone === undefined) {
			return format(date, pattern, { locale })
		}

		const timeZoneFormat = this.translateOffset2TimeZone(timeZone)
		const parisDate = utcToZonedTime(date, timeZoneFormat)
		return format(parisDate, pattern, { timeZone: timeZoneFormat, locale })
	}

	formatISODate(
		ISOdate: Date | number,
		pattern: string,
		lang: string,
		timeZone: string,
	) {
		const locale = this.getLocale(lang)
		const convertDate = toDate(ISOdate)
		if (timeZone === undefined) {
			return format(convertDate, pattern, { locale })
		}

		const timeZoneFormat = this.translateOffset2TimeZone(timeZone)
		const parisDate = utcToZonedTime(convertDate, timeZoneFormat)
		return format(parisDate, pattern, { timeZone: timeZoneFormat, locale })
	}
}
